import { useContext, useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";

import { TbLoader2 } from "react-icons/tb";
import { MdOutlineArrowBackIos, MdOutlineArrowForwardIos } from "react-icons/md";
import { useModal } from "../../../contexts/ModalContext";
import ModalAddMeta from "./ModalAddMeta";
import Overlay from "../../../Componentes/Overlay";
import SideMenu from "../../../Componentes/SideMenu";
import SideMenuBtn from "../../../Componentes/SideMenuBtn";
import { VerifyPermission } from "../../../Funcoes/VerifyPermission";
import { AuthContext } from "../../../Auth/AuthProvider";
import UserMetas from "./UserMetas";


import useApi from "../../../hooks/useApi";
const spin = keyframes`
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
`;

const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: #FFF;
    border: 1px solid #CCC;
    box-sizing: border-box;
    border-radius: 15px;
    overflow: auto;
`
const Tabela = styled.table`
    width: 100%;
    border-collapse: collapse;
    box-sizing: border-box;
`
const TituloCelula = styled.th`
    text-align: left;
    border-bottom: 1px solid #CCC;
    padding: 10px 0 10px 10px;
    & h3 {
        margin: 0;
        font-size: 15px;
    }
`
const CelulaDesc = styled.th`
    padding: 10px 0 10px 10px;
    text-align: left;
    border-bottom: 1px solid #bbbbbb;
    font-size: 13px;
`
const LinhaCorpo = styled.tr`
    cursor: pointer;
    &:nth-child(even) {
        background-color: #f9f9f9;
    }
    &:hover {
        background-color: #d8f2ee;
    }
`
const CelulaValor = styled.td`
    padding: 10px 0 10px 10px;
    text-align: left;
    border-bottom: 1px solid #CCC;
    font-size: 12px;
    color: #555;
    width: ${props => props.width + 'px' || 'auto'};
`
const ContainerValorProgresso = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`
const ContainerProgresso = styled.div`
    width: 70px;
    height: 5px;
    background-color: #e0e0e0;
    border-radius: 10px;
    overflow: hidden;
`
const BarraProgresso = styled.div`
    height: 100%;
    background-color:
        ${props => props.percent === 100 ? '#4caf50' : props.percent >= 50 ? '#ffeb3b' : '#f44336'}
    ;
    width: ${props => props.percent}%;
    border-radius: 10px 0 0 10px;
`
const ContainerCarregando = styled.div`
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    font-size: 14px;
`
const ContainerIconLoading = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
`
const ContainerTitulo = styled.div`
    width: 100%;
    display: flex;
    h3{
        margin: 0;
        font-size: 15px;
    }
`
const IconLoading = styled(TbLoader2)`
    width: 100%;
    height: 100%;
    animation: ${spin} 1s linear infinite;
`
const ContainerData = styled.div`
    display: flex;
    gap: 5px;
    font-size: 12px;
    align-items: center;
    margin-left: auto;
    margin-right: 15px;
`
const IconBack = styled(MdOutlineArrowBackIos)`
    width: 15px;
    height: 15px;
    cursor: pointer;
`
const IconForward = styled(MdOutlineArrowForwardIos)`
    width: 15px;
    height: 15px;
    cursor: pointer;
`

const Metas = () => {
    const api = useApi();


    const { isModalOpen, closeModal, openModal } = useModal();
    const { user } = useContext(AuthContext);

    const closeSidebar = () => {
        closeModal();
    }

    const openNewModal = () => {

        closeSidebar();
        openModal("modalAddMeta");

    }

    const calcularProgresso = (concluido, meta) => {
        if (meta === 0) return 0;
        const percent = (concluido / meta) * 100;
        return Math.max(0, Math.min(percent, 100));
    }

    const formatarData = (data) => {
        return data.toLocaleDateString("pt-BR");
    }

    const [offset, setOffset] = useState(0);

    const CalcularSemana = () => {
        const base = new Date();
        base.setDate(base.getDate() + offset * 7);

        const diaSemana = base.getDay();
        const diffParaSegunda = (diaSemana === 0 ? -6 : 1 - diaSemana)

        const segunda = new Date(base);
        segunda.setDate(base.getDate() + diffParaSegunda);

        const domingo = new Date(segunda);
        domingo.setDate(segunda.getDate() + 6);

        return { segunda, domingo };
    }

    const { segunda, domingo } = CalcularSemana();

    useEffect(() => {
        fetchDados();
    }, []);

    const mudarSemana = (sinal) => {

        if (sinal === 'proxima') {
            setOffset(prev => prev + 1);
        } else if (sinal === 'anterior') {
            setOffset(prev => prev - 1);
        } else {
            setOffset(0);
        }
    }

    useEffect(() => {

        fetchDados();

    }, [offset])

    const [dados, setDados] = useState([]);

    const [loading, setLoading] = useState(true);

    const fetchDados = async () => {
        setLoading(true);

        try {
            const { data } = await api.post('/Painel/API/Checklist/GetMetas/', {
                data_inicial: formatarData(segunda),
                data_final: formatarData(domingo)
            })

            console.log(data);
            setDados(data);

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    const [selectedUser, setSelectedUser] = useState(null);

    const openUserModal = (user) => {

        setSelectedUser(user)
        openModal('userMetasModal');

    }

    const closeUserModal = () => {

        setSelectedUser( null );
        closeModal();

    }

    return (
        <>
            <Container>
                {
                    loading ? (
                        <ContainerCarregando>
                            <span>CARREGANDO DADOS...</span>
                            <ContainerIconLoading>
                                <IconLoading />
                            </ContainerIconLoading>
                        </ContainerCarregando>
                    ) : (
                        <Tabela>
                            <thead>
                                <tr>
                                    <TituloCelula colSpan={6} >
                                        <ContainerTitulo>
                                            <h3>METAS CHECKLIST</h3>
                                            <ContainerData>
                                                <IconBack onClick={() => mudarSemana('anterior')} />
                                                <span>{formatarData(segunda)} - {formatarData(domingo)}</span>
                                                <IconForward onClick={() => mudarSemana('proxima')} />
                                            </ContainerData>
                                        </ContainerTitulo>
                                    </TituloCelula>
                                </tr>
                                <tr>
                                    <CelulaDesc>MATRICULA</CelulaDesc>
                                    <CelulaDesc>USUÁRIO</CelulaDesc>
                                    <CelulaDesc>FUNÇÃO</CelulaDesc>
                                    <CelulaDesc>E-MAIL</CelulaDesc>
                                    <CelulaDesc>PREENCHIDOS</CelulaDesc>
                                    <CelulaDesc>CONCLUSÃO</CelulaDesc>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    dados.map((item) => {
                                        const progresso = calcularProgresso(item.tipos_concluidos, item.total_tipos);

                                        return (
                                            <LinhaCorpo key={item.usuario_id} onClick={() => openUserModal(item)} >
                                                <CelulaValor>{item.matricula}</CelulaValor>
                                                <CelulaValor>{item.nome}</CelulaValor>
                                                <CelulaValor>{item.funcao}</CelulaValor>
                                                <CelulaValor>{item.email}</CelulaValor>
                                                <CelulaValor>{item.total_preenchidos}</CelulaValor>
                                                <CelulaValor width={160} >
                                                    <ContainerValorProgresso>
                                                        <ContainerProgresso>
                                                            <BarraProgresso percent={progresso} />
                                                        </ContainerProgresso>
                                                        {progresso.toFixed(2)}%
                                                    </ContainerValorProgresso>
                                                </CelulaValor>
                                            </LinhaCorpo>
                                        )
                                    })
                                }
                            </tbody>
                        </Tabela>
                    )
                }
            </Container>
            {
                isModalOpen("sidebarChecklistMetas") && (
                    <>
                        <Overlay state={true} changeContent={closeSidebar} >
                            <SideMenu>
                                {
                                    VerifyPermission(user, { modulo: 'ssma', submodulo: 'check-list', permissao: 'adicionar-meta' }) && (
                                        <SideMenuBtn
                                            button="ADICIONAR META"
                                            clickFunc={openNewModal}
                                        />
                                    )
                                }
                            </SideMenu>
                        </Overlay>
                    </>
                )
            }
            {
                isModalOpen("modalAddMeta") && <ModalAddMeta updateData={fetchDados} />
            }
            {
                isModalOpen("userMetasModal") && (
                    <UserMetas UpdateUsers={ fetchDados } fecharModal={ closeUserModal } usuario={ selectedUser } data_inicio={ segunda } data_final={ domingo } />
                )
            }
        </>
    )
}

export default Metas;